import { Position } from 'geojson';

export const MS_TO_KT = 1.9438444924406;
export const NM_TO_M = 1852;

export function fix180LineInPlace(positions: Position[]): void {

    if (positions.length < 1) {
        return;
    }

    const startLng = positions[0][0];

    for (let i = 1; i < positions.length; i++) {
        if (positions[i][0] - startLng >= 180) {
            positions[i][0] -= 360;
        } else if (positions[i][0] - startLng <= -180) {
            positions[i][0] += 360;
        }
    }
}

/**
 * Fixes longitude coordinates to prevent crossing the 180° meridian when drawing lines
 *
 * @param start - Starting position as [longitude, latitude] in decimal degrees
 * @param end - Ending position as [longitude, latitude] in decimal degrees
 * @returns A tuple containing the original start position and adjusted end position
 **/

export function fix180Position(start: Position, end: Position): [Position, Position] {
    const startLng = start[0];
    let endLng = end[0];

    if (endLng - startLng >= 180) {
        endLng -= 360;
    } else if (endLng - startLng <= -180) {
        endLng += 360;
    }

    return [start, [endLng, end[1]]];
}

/**
 * Fixes a longitude value to prevent crossing the 180° meridian
 *
 * This function adjusts the end longitude to ensure the shortest angular path between
 * two longitude values doesn't cross the international date line (±180° longitude).
 *
 * @param startLng - Starting longitude in decimal degrees (range: -180 to 180)
 * @param endLng - Ending longitude in decimal degrees (range: -180 to 180)
 * @returns The adjusted ending longitude that avoids crossing the date line
 **/

export function fix180Longitude(startLng: number, endLng: number): number {
    if (endLng - startLng >= 180) {
        endLng -= 360;
    } else if (endLng - startLng <= -180) {
        endLng += 360;
    }

    return endLng;
}

export function metersToFt(meters: number) {
    return meters * 3.28084;
}
